module.exports = __webpack_public_path__ + "img/pk.2ec55e95.gif";